import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _slicedToArray from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableselection
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TableWalker from './tablewalker';
import TableUtils from './tableutils';
import MouseEventsObserver from './tableselection/mouseeventsobserver';
import { getSelectedTableCells as _getSelectedTableCells, getTableCellsContainingSelection } from './utils';
import { findAncestor } from './commands/utils';
import cropTable from './tableselection/croptable';
import '../theme/tableselection.css';
/**
 * This plugin enables the advanced table cells/rows/columns selection.
 * It is loaded automatically by the {@link module:table/table~Table} plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableSelection = /*#__PURE__*/function (_Plugin) {
  _inherits(TableSelection, _Plugin);

  var _super = _createSuper(TableSelection);

  function TableSelection() {
    _classCallCheck(this, TableSelection);

    return _super.apply(this, arguments);
  }

  _createClass(TableSelection, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var _this = this;

      var editor = this.editor;
      var model = editor.model;
      this.listenTo(model, 'deleteContent', function (evt, args) {
        return _this._handleDeleteContent(evt, args);
      }, {
        priority: 'high'
      }); // Currently the MouseObserver only handles `mouseup` events.
      // TODO move to the engine?

      editor.editing.view.addObserver(MouseEventsObserver);

      this._defineSelectionConverter();

      this._enableShiftClickSelection();

      this._enableMouseDragSelection();
    }
    /**
     * Returns currently selected table cells or `null` if not a table cells selection.
     *
     * @returns {Array.<module:engine/model/element~Element>|null}
     */

  }, {
    key: "getSelectedTableCells",
    value: function getSelectedTableCells() {
      var selection = this.editor.model.document.selection;

      var selectedCells = _getSelectedTableCells(selection);

      if (selectedCells.length == 0) {
        return null;
      } // This should never happen, but let's know if it ever happens.
      // @if CK_DEBUG //	if ( selectedCells.length != selection.rangeCount ) {
      // @if CK_DEBUG //		console.warn( 'Mixed selection warning. The selection contains table cells and some other ranges.' );
      // @if CK_DEBUG //	}


      return selectedCells;
    }
    /**
     * Returns a selected table fragment as a document fragment.
     *
     * @returns {module:engine/model/documentfragment~DocumentFragment|null}
     */

  }, {
    key: "getSelectionAsFragment",
    value: function getSelectionAsFragment() {
      var _this2 = this;

      var selectedCells = this.getSelectedTableCells();

      if (!selectedCells) {
        return null;
      }

      return this.editor.model.change(function (writer) {
        var documentFragment = writer.createDocumentFragment();
        var table = cropTable(selectedCells, _this2.editor.plugins.get('TableUtils'), writer);
        writer.insert(table, documentFragment, 0);
        return documentFragment;
      });
    }
    /**
     * Defines a selection converter which marks selected cells with a specific class.
     *
     * The real DOM selection is put in the last cell. Since the order of ranges is dependent on whether the
     * selection is backward or not, the last cell with usually be close to the "focus" end of the selection
     * (a selection has anchor and focus).
     *
     * The real DOM selection is then hidden with CSS.
     *
     * @private
     */

  }, {
    key: "_defineSelectionConverter",
    value: function _defineSelectionConverter() {
      var _this3 = this;

      var editor = this.editor;
      var highlighted = new Set();
      editor.conversion.for('editingDowncast').add(function (dispatcher) {
        return dispatcher.on('selection', function (evt, data, conversionApi) {
          var viewWriter = conversionApi.writer;
          clearHighlightedTableCells(viewWriter);

          var selectedCells = _this3.getSelectedTableCells();

          if (!selectedCells) {
            return;
          }

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = selectedCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var tableCell = _step.value;
              var viewElement = conversionApi.mapper.toViewElement(tableCell);
              viewWriter.addClass('ck-editor__editable_selected', viewElement);
              highlighted.add(viewElement);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var lastViewCell = conversionApi.mapper.toViewElement(selectedCells[selectedCells.length - 1]);
          viewWriter.setSelection(lastViewCell, 0);
        }, {
          priority: 'lowest'
        });
      });

      function clearHighlightedTableCells(writer) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = highlighted[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var previouslyHighlighted = _step2.value;
            writer.removeClass('ck-editor__editable_selected', previouslyHighlighted);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        highlighted.clear();
      }
    }
    /**
     * Enables making cells selection by Shift+click. Creates a selection from the cell which previously hold
     * the selection to the cell which was clicked (can be the same cell, in which case it selects a single cell).
     *
     * @private
     */

  }, {
    key: "_enableShiftClickSelection",
    value: function _enableShiftClickSelection() {
      var _this4 = this;

      var editor = this.editor;
      var blockSelectionChange = false;
      this.listenTo(editor.editing.view.document, 'mousedown', function (evt, domEventData) {
        if (!_this4.isEnabled) {
          return;
        }

        if (!domEventData.domEvent.shiftKey) {
          return;
        }

        var anchorCell = getTableCellsContainingSelection(editor.model.document.selection)[0];

        if (!anchorCell) {
          return;
        }

        var targetCell = _this4._getModelTableCellFromDomEvent(domEventData);

        if (targetCell && haveSameTableParent(anchorCell, targetCell)) {
          blockSelectionChange = true;

          _this4._setCellSelection(anchorCell, targetCell);

          domEventData.preventDefault();
        }
      });
      this.listenTo(editor.editing.view.document, 'mouseup', function () {
        blockSelectionChange = false;
      }); // We need to ignore a `selectionChange` event that is fired after we render our new table cells selection.
      // When downcasting table cells selection to the view, we put the view selection in the last selected cell
      // in a place that may not be natively a "correct" location. This is – we put it directly in the `<td>` element.
      // All browsers fire the native `selectionchange` event.
      // However, all browsers except Safari return the selection in the exact place where we put it
      // (even though it's visually normalized). Safari returns `<td><p>^foo` that makes our selection observer
      // fire our `selectionChange` event (because the view selection that we set in the first step differs from the DOM selection).
      // Since `selectionChange` is fired, we automatically update the model selection that moves it that paragraph.
      // This breaks our dear cells selection.
      //
      // Theoretically this issue concerns only Safari that is the only browser that do normalize the selection.
      // However, to avoid code branching and to have a good coverage for this event blocker, I enabled it for all browsers.
      //
      // Note: I'm keeping the `blockSelectionChange` state separately for shift+click and mouse drag (exact same logic)
      // so I don't have to try to analyze whether they don't overlap in some weird cases. Probably they don't.
      // But I have other things to do, like writing this comment.

      this.listenTo(editor.editing.view.document, 'selectionChange', function (evt) {
        if (blockSelectionChange) {
          // @if CK_DEBUG // console.log( 'Blocked selectionChange to avoid breaking table cells selection.' );
          evt.stop();
        }
      }, {
        priority: 'highest'
      });
    }
    /**
     * Enables making cells selection by dragging.
     *
     * The selection is made only on mousemove. We start tracking the mouse on mousedown.
     * However, the cells selection is enabled only after the mouse cursor left the anchor cell.
     * Thanks to that normal text selection within one cell works just fine. However, you can still select
     * just one cell by leaving the anchor cell and moving back to it.
     *
     * @private
     */

  }, {
    key: "_enableMouseDragSelection",
    value: function _enableMouseDragSelection() {
      var _this5 = this;

      var editor = this.editor;
      var anchorCell, targetCell;
      var beganCellSelection = false;
      var blockSelectionChange = false;
      this.listenTo(editor.editing.view.document, 'mousedown', function (evt, domEventData) {
        if (!_this5.isEnabled) {
          return;
        } // Make sure to not conflict with the shift+click listener and any other possible handler.


        if (domEventData.domEvent.shiftKey || domEventData.domEvent.ctrlKey || domEventData.domEvent.altKey) {
          return;
        }

        anchorCell = _this5._getModelTableCellFromDomEvent(domEventData);
      });
      this.listenTo(editor.editing.view.document, 'mousemove', function (evt, domEventData) {
        if (!domEventData.domEvent.buttons) {
          return;
        }

        if (!anchorCell) {
          return;
        }

        var newTargetCell = _this5._getModelTableCellFromDomEvent(domEventData);

        if (newTargetCell && haveSameTableParent(anchorCell, newTargetCell)) {
          targetCell = newTargetCell; // Switch to the cell selection mode after the mouse cursor left the anchor cell.
          // Switch off only on mouseup (makes selecting a single cell possible).

          if (!beganCellSelection && targetCell != anchorCell) {
            beganCellSelection = true;
          }
        } // Yep, not making a cell selection yet. See method docs.


        if (!beganCellSelection) {
          return;
        }

        blockSelectionChange = true;

        _this5._setCellSelection(anchorCell, targetCell);

        domEventData.preventDefault();
      });
      this.listenTo(editor.editing.view.document, 'mouseup', function () {
        beganCellSelection = false;
        blockSelectionChange = false;
        anchorCell = null;
        targetCell = null;
      }); // See the explanation in `_enableShiftClickSelection()`.

      this.listenTo(editor.editing.view.document, 'selectionChange', function (evt) {
        if (blockSelectionChange) {
          // @if CK_DEBUG // console.log( 'Blocked selectionChange to avoid breaking table cells selection.' );
          evt.stop();
        }
      }, {
        priority: 'highest'
      });
    }
    /**
     * It overrides the default `model.deleteContent()` behavior over a selected table fragment.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} event
     * @param {Array.<*>} args Delete content method arguments.
     */

  }, {
    key: "_handleDeleteContent",
    value: function _handleDeleteContent(event, args) {
      var _args = _slicedToArray(args, 2),
          selection = _args[0],
          options = _args[1];

      var model = this.editor.model;
      var isBackward = !options || options.direction == 'backward';

      var selectedTableCells = _getSelectedTableCells(selection);

      if (!selectedTableCells.length) {
        return;
      }

      event.stop();
      model.change(function (writer) {
        var tableCellToSelect = selectedTableCells[isBackward ? selectedTableCells.length - 1 : 0];
        model.change(function (writer) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = selectedTableCells[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var tableCell = _step3.value;
              model.deleteContent(writer.createSelection(tableCell, 'in'));
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        });
        var rangeToSelect = model.schema.getNearestSelectionRange(writer.createPositionAt(tableCellToSelect, 0));

        if (rangeToSelect) {
          if (selection.is('documentSelection')) {
            writer.setSelection(rangeToSelect);
          } else {
            selection.setTo(rangeToSelect);
          }
        }
      });
    }
    /**
     * Sets the model selection based on given anchor and target cells (can be the same cell).
     * Takes care of setting backward flag.
     *
     * @protected
     * @param {module:engine/model/element~Element} anchorCell
     * @param {module:engine/model/element~Element} targetCell
     */

  }, {
    key: "_setCellSelection",
    value: function _setCellSelection(anchorCell, targetCell) {
      var cellsToSelect = this._getCellsToSelect(anchorCell, targetCell);

      this.editor.model.change(function (writer) {
        writer.setSelection(cellsToSelect.cells.map(function (cell) {
          return writer.createRangeOn(cell);
        }), {
          backward: cellsToSelect.backward
        });
      });
    }
    /**
     * Returns the model table cell element based on the target element of the passed DOM event.
     *
     * @private
     * @param {module:engine/view/observer/domeventdata~DomEventData} domEventData
     * @returns {module:engine/model/element~Element|undefined} Returns the table cell or `undefined`.
     */

  }, {
    key: "_getModelTableCellFromDomEvent",
    value: function _getModelTableCellFromDomEvent(domEventData) {
      // Note: Work with positions (not element mapping) because the target element can be an attribute or other non-mapped element.
      var viewTargetElement = domEventData.target;
      var viewPosition = this.editor.editing.view.createPositionAt(viewTargetElement, 0);
      var modelPosition = this.editor.editing.mapper.toModelPosition(viewPosition);
      var modelElement = modelPosition.parent;

      if (!modelElement) {
        return;
      }

      if (modelElement.is('tableCell')) {
        return modelElement;
      }

      return findAncestor('tableCell', modelElement);
    }
    /**
     * Returns an array of table cells that should be selected based on the
     * given anchor cell and target (focus) cell.
     *
     * The cells are returned in a reverse direction if the selection is backward.
     *
     * @private
     * @param {module:engine/model/element~Element} anchorCell
     * @param {module:engine/model/element~Element} targetCell
     * @returns {Array.<module:engine/model/element~Element>}
     */

  }, {
    key: "_getCellsToSelect",
    value: function _getCellsToSelect(anchorCell, targetCell) {
      var tableUtils = this.editor.plugins.get('TableUtils');
      var startLocation = tableUtils.getCellLocation(anchorCell);
      var endLocation = tableUtils.getCellLocation(targetCell);
      var startRow = Math.min(startLocation.row, endLocation.row);
      var endRow = Math.max(startLocation.row, endLocation.row);
      var startColumn = Math.min(startLocation.column, endLocation.column);
      var endColumn = Math.max(startLocation.column, endLocation.column);
      var cells = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = new TableWalker(findAncestor('table', anchorCell), {
          startRow: startRow,
          endRow: endRow
        })[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var cellInfo = _step4.value;

          if (cellInfo.column >= startColumn && cellInfo.column <= endColumn) {
            cells.push(cellInfo.cell);
          }
        } // A selection started in the bottom right corner and finished in the upper left corner
        // should have it ranges returned in the reverse order.
        // However, this is only half of the story because the selection could be made to the left (then the left cell is a focus)
        // or to the right (then the right cell is a focus), while being a forward selection in both cases
        // (because it was made from top to bottom). This isn't handled.
        // This method would need to be smarter, but the ROI is microscopic, so I skip this.

      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (checkIsBackward(startLocation, endLocation)) {
        return {
          cells: cells.reverse(),
          backward: true
        };
      }

      return {
        cells: cells,
        backward: false
      };
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'TableSelection';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableUtils];
    }
  }]);

  return TableSelection;
}(Plugin); // Naively check whether the selection should be backward or not. See the longer explanation where this function is used.


export { TableSelection as default };

function checkIsBackward(startLocation, endLocation) {
  if (startLocation.row > endLocation.row) {
    return true;
  }

  if (startLocation.row == endLocation.row && startLocation.column > endLocation.column) {
    return true;
  }

  return false;
}

function haveSameTableParent(cellA, cellB) {
  return cellA.parent.parent == cellB.parent.parent;
}